import { Instance, types as t } from 'mobx-state-tree';
import { SlateEditor } from '../../SlateObj/slate-editor.store';

export const CompactGuideline = t.model('CompactGuidelineSlate', {
  content: t.array(SlateEditor),
  enable: t.maybeNull(t.boolean),
});

export interface CompactGuidelineInstance extends Instance<typeof CompactGuideline> {}
